import gsap from "gsap";
import { incrementValue, tweenFade, tweenScaleAppear, tweenScaleDisAppear } from "./utility";
import { fruitData } from "./data";
import { playCoinAnimation, stopCoinAnimation } from "./coins";
import { checkGrandJackpotVisible, controlJackpotWinSpine, instances } from "./gameUI";
import { restartGame } from "./gameLogic";
import { playBigWin, playEnkC, playMegaAudio, playMegaWin, playMiniAudio, playUltraAudio, playUltraWin } from "./soundManager";

const newWinAnimations = ["version 1/bigwin", "version 1/bigwin_and_megawin", "version 1/bigwin_and_megawin_and_ultrawin"]

export const COMMENDATION = Object.freeze({
    NONE: "none",
    NORMAL: "normal",
    BIG: "big",
    MEGA: "mega",
    ULTRA: "ultra",
    MINOR: "minor",
    MAJOR: "major",
    GRAND: "grand",
});

export let commendationType = COMMENDATION.NONE;
export const setCommendationType = (c) => (commendationType = c);

let flag = true;
let delayedCalls = [];
const listeners = [];
let delayedCall = null,
    commendationAmount = 0;

let loopCalls = [];
let loopCall = null;
let trackAnimation = null;
let fontChangedToSilver = false;

let duration = 0;

const animationArray = [
    "jackpot/fx_in", //0
    "jackpot/fx_loop",
    "jackpot/fx_out",
    "big_win_in", // 3
    "big_win_loop",
    "big_win_out",
    "mega_win_in", // 6
    "mega_win_loop",
    "mega_win_out",
    "ultra_win_in", // 9
    "ultra_win_loop",
    "ultra_win_out",
    "jackpot/minor_in", // 12
    "jackpot/minor_loop",
    "jackpot/minor_out",
    "jackpot/major_in", // 15
    "jackpot/major_loop",
    "jackpot/major_out",
    "jackpot/grand_in", //18
    "jackpot/grand_loop",
    "jackpot/grand_out",
];

const setUpAnimation = (spineObject, animationIndex, isLoop) => {
    const animation = animationArray[animationIndex];

    if (animation) {
        // const spineObject = animationIndex < 3 ? gameAssets.amazing : gameAssets.commendation

        spineObject.visible = true;
        spineObject.state.setAnimation(0, animation, isLoop);
        // spineObject.resize(settings.currentWidth, settings.currentHeight)
    } else {
        console.warn(`Animation at index ${animationIndex} not found.`);
    }
};

const setupNewWinAnimation = (spineObject, animationIndex, isLoop, backgroundBlur, textObject) => {
    const animation = newWinAnimations[animationIndex];

    if (animation) {
        spineObject.visible = true;

        trackAnimation = spineObject.state.setAnimation(0, animation, isLoop);

        const checkFontChange = setInterval(() => {
            if (!trackAnimation || trackAnimation.isComplete()) {
                clearInterval(checkFontChange);
                return;
            }

            if (animationIndex === 0) clearInterval(checkFontChange);

            if (trackAnimation.trackTime >= 15 && flag) {
                console.log("Changing font to Gold");

                textObject.fontName = "gold-font";

                clearInterval(checkFontChange);
            } else if (trackAnimation.trackTime >= 7 && !fontChangedToSilver && flag) {
                textObject.fontName = "silver-font";

                if (animationIndex === 1) clearInterval(checkFontChange)
                fontChangedToSilver = true;

            }
        }, 100);


        if (trackAnimation && trackAnimation.animation) {
            duration = trackAnimation.animation.duration;
        }

        trackAnimation.listener = {
            complete: () => {

                stopCoinAnimation();
                if (!flag) {
                    playBigWin(false);
                    playMegaWin(false);
                    playUltraWin(false);
                    playEnkC(true)
                }
                clearInterval(checkFontChange)
                tweenScaleDisAppear(textObject, 0.1);
                backgroundBlur.interactive = false;
                backgroundBlur.visible = false;
                spineObject.interactive = false;
                spineObject.visible = false;
                duration = 0;
                flag = true;
                fontChangedToSilver = false;

                listeners.forEach((listener) => spineObject.off("pointerdown", listener));
                stopDelayedCalls()

                if (!fruitData.jackpot) {
                    tweenFade(backgroundBlur, false, 0.2);
                    console.log("from-commendation.js");

                    restartGame()
                } else {
                    instances.winScreen.jackpot()
                }
            }
        };
    } else {
        console.warn(`Animation at index ${animationIndex} not found.`);
    }
};

export const bigWin = (backgroundBlur, textObject, amt, gameObject) => {
    commendationAmount = amt;
    gameObject.interactive = true;
    fruitData.showWinAmount = true;
    playBigWin(true);
    playCoinAnimation(0)
    tweenFade(backgroundBlur, true, 0.2);

    setupNewWinAnimation(gameObject, 0, false, backgroundBlur, textObject);

    delayedCall = gsap.delayedCall(1.5, () => {
        textObject.visible = true;
        textObject.text = 0;

        tweenScaleAppear(textObject, 0.5, () => {
            delayedCall = gsap.delayedCall(0.2, () =>
                increaseNumCount(textObject, amt, duration)
            );
            delayedCalls.push(delayedCall);
        });
    });
    delayedCalls.push(delayedCall);


    const pointerDownListener = () => {
        if (fruitData.showWinAmount) {
            stopNumberCounter(textObject, amt);
        } else if (flag) {
            trackAnimation.trackTime = 6;
            flag = false;
        }
    };

    gameObject.on("pointerdown", pointerDownListener);
    listeners.push(pointerDownListener);

};

export const megaWin = (backgroundBlur, textObject, amt, gameObject) => {
    playMegaWin(true);
    playCoinAnimation(1);
    gameObject.interactive = true;
    fruitData.showWinAmount = true;
    tweenFade(backgroundBlur, true, 0.2);


    setupNewWinAnimation(gameObject, 1, false, backgroundBlur, textObject)

    delayedCall = gsap.delayedCall(1.5, () => {
        textObject.visible = true;
        textObject.text = 0;
        tweenScaleAppear(textObject, 0.5, () => {
            delayedCall = gsap.delayedCall(0.2, () =>
                increaseNumCount(textObject, amt, duration)
            );
            delayedCalls.push(delayedCall);
        });
    });
    delayedCalls.push(delayedCall);

    const pointerDownListener = () => {
        if (fruitData.showWinAmount) {
            stopNumberCounter(textObject, amt)
        } else if (flag) {
            textObject.fontName = "silver-font"
            trackAnimation.trackTime = 14;
            flag = false;
        }
    };
    gameObject.on("pointerdown", pointerDownListener);
    listeners.push(pointerDownListener);

};

export const ultraWin = (backgroundBlur, textObject, amt, gameObject) => {

    playUltraWin(true);
    playCoinAnimation(2)
    tweenFade(backgroundBlur, true, 0.2)
    fruitData.showWinAmount = true;
    gameObject.interactive = true;

    setupNewWinAnimation(gameObject, 2, false, backgroundBlur, textObject)


    delayedCall = gsap.delayedCall(1.5, () => {
        textObject.visible = true;
        textObject.text = 0;
        tweenScaleAppear(textObject, 0.5, () => {
            delayedCall = gsap.delayedCall(0.2, () =>
                increaseNumCount(textObject, amt, duration)
            );
            delayedCalls.push(delayedCall);
        });
    });
    delayedCalls.push(delayedCall);

    const pointerDownListener = () => {

        if (fruitData.showWinAmount) {
            stopNumberCounter(textObject, amt)
        } else if (flag) {
            textObject.fontName = "gold-font"
            trackAnimation.trackTime = 22;
            flag = false;
        }
    };

    gameObject.on("pointerdown", pointerDownListener);
    listeners.push(pointerDownListener);

};

export const minorJackpot = (gameObject, amt, backgroundBlur, textObject) => {
    fruitData.jackpotMinorWin = false;
    fruitData.showAmount = true;
    commendationAmount = amt;
    gameObject.interactive = true;
    playMiniAudio(true);
    playCoinAnimation(0)
    tweenFade(backgroundBlur, true, 0.2);

    delayedCall = gsap.delayedCall(1.5, () => {
        textObject.visible = true;
        textObject.text = 0;

        tweenScaleAppear(
            textObject,
            0.5,
            () =>
            (delayedCall = gsap.delayedCall(0.2, () => {
                if (!fruitData.showAmount) return;
                increaseNumCount(textObject, amt)
            }
            ))
        );
    });
    delayedCalls.push(delayedCall);

    const pointerDownListener = () => {
        clickToStopCommendation(backgroundBlur, gameObject, textObject, amt, 14);
    };

    gameObject.on("pointerdown", pointerDownListener);
    listeners.push(pointerDownListener);


    setUpAnimation(gameObject, 12, false);
    loopCall = gsap.delayedCall(2, () => {
        setUpAnimation(gameObject, 13, true);
    });
    loopCalls.push(loopCall);

    delayedCall = gsap.delayedCall(8, () => {
        setUpAnimation(gameObject, 14, false);


        listeners.forEach((listener) => gameObject.off("pointerdown", listener));
        if (fruitData.jackpotMajorWin) {
            textObject.fontName = "silver-font";
            fruitData.jackpotMinorWin = false;
            controlJackpotWinSpine(0, false);
            controlJackpotWinSpine(1, true);
            majorJackpot(gameObject, fruitData.jackpotMajorWinAmount, backgroundBlur, textObject);
            setCommendationType(COMMENDATION.MAJOR)

        } else if (fruitData.jackpotGrandWin) {
            fruitData.jackpotMajorWin = false;
            textObject.fontName = "gold-font";
            controlJackpotWinSpine(0, false);
            controlJackpotWinSpine(2, true);
            grandJackpot(gameObject, fruitData.jackpotGrandWinAmount, backgroundBlur, textObject);
            setCommendationType(COMMENDATION.GRAND)
        }

        tweenScaleDisAppear(textObject, false);
        stopCoinAnimation();
        if (commendationType === COMMENDATION.MINOR) {
            playEnkC(true)
            setCommendationType(COMMENDATION.NONE);
            tweenFade(backgroundBlur, false, 0.2);
            commendationAmount = 0;
            delayedCall = null;
            delayedCalls = [];

            loopCalls = [];
            loopCall = null;
            textObject.visible = false;
            backgroundBlur.interactive = false;

            setTimeout(() => {
                gameObject.visible = false;
                gameObject.interactive = false;
                restartGame();
            }, 1000)
        }
    });
    delayedCalls.push(delayedCall);
};

export const majorJackpot = (gameObject, amt, backgroundBlur, textObject) => {
    fruitData.jackpotMajorWin = false;
    fruitData.showAmount = true;
    commendationAmount = amt;
    playCoinAnimation(1)
    gameObject.interactive = true
    playMiniAudio(false)
    playMegaAudio(true);
    tweenFade(backgroundBlur, true, 0.2);

    delayedCall = gsap.delayedCall(1.5, () => {
        textObject.visible = true;
        textObject.text = 0;

        tweenScaleAppear(
            textObject,
            0.5,
            () =>
            (delayedCall = gsap.delayedCall(0.2, () => {
                if (!fruitData.showAmount) return;
                increaseNumCount(textObject, amt)
            }
            ))
        );
    });
    delayedCalls.push(delayedCall);

    const pointerDownListener = () => {
        clickToStopCommendation(backgroundBlur, gameObject, textObject, amt, 17);
    };

    gameObject.on("pointerdown", pointerDownListener);
    listeners.push(pointerDownListener);


    setUpAnimation(gameObject, 15, false);
    loopCall = gsap.delayedCall(2, () => {
        setUpAnimation(gameObject, 16, true);
    });
    loopCalls.push(loopCall);

    delayedCall = gsap.delayedCall(9, () => {
        setUpAnimation(gameObject, 17, false);

        listeners.forEach((listener) => gameObject.off("pointerdown", listener));
        if (fruitData.jackpotGrandWin) {
            textObject.fontName = "gold-font";
            fruitData.jackpotMajorWin = false;
            controlJackpotWinSpine(1, false);
            controlJackpotWinSpine(2, true);
            grandJackpot(gameObject, fruitData.jackpotGrandWinAmount, backgroundBlur, textObject);
            setCommendationType(COMMENDATION.GRAND)

        }

        tweenScaleDisAppear(textObject, false);
        if (commendationType === COMMENDATION.MAJOR) {
            playEnkC(true)
            stopCoinAnimation();
            setCommendationType(COMMENDATION.NONE);
            tweenFade(backgroundBlur, false, 0.2);
            commendationAmount = 0;
            delayedCall = null;
            delayedCalls = [];

            loopCalls = [];
            loopCall = null
            textObject.visible = false;
            backgroundBlur.interactive = false;
            setTimeout(() => {
                gameObject.visible = false;
                gameObject.interactive = false;
                restartGame();
            }, 1000)
        }
    });
    delayedCalls.push(delayedCall);
};



export const grandJackpot = (gameObject, amt, backgroundBlur, textObject) => {
    fruitData.jackpotGrandWin = false;
    commendationAmount = amt;
    fruitData.showAmount = true;
    playCoinAnimation(2)
    gameObject.interactive = true
    playMiniAudio(false);
    playMegaAudio(false);
    playUltraAudio(true);
    tweenFade(backgroundBlur, true, 0.2);

    delayedCall = gsap.delayedCall(1.5, () => {
        textObject.visible = true;
        textObject.text = 0;
        tweenScaleAppear(
            textObject,
            0.5,
            () =>
            (delayedCall = gsap.delayedCall(0.2, () => {
                if (!fruitData.showAmount) return;
                increaseNumCount(textObject, amt)
            }
            ))
        );
    });
    delayedCalls.push(delayedCall);

    const pointerDownListener = () => {
        clickToStopCommendation(backgroundBlur, gameObject, textObject, amt, 20);
    };

    gameObject.on("pointerdown", pointerDownListener);
    listeners.push(pointerDownListener);


    setUpAnimation(gameObject, 18, false);
    loopCall = gsap.delayedCall(2, () => {
        setUpAnimation(gameObject, 19, true);
    });
    loopCalls.push(loopCall);

    delayedCall = gsap.delayedCall(9, () => {
        setUpAnimation(gameObject, 20, false);
        tweenScaleDisAppear(textObject, false);
        stopCoinAnimation();
        listeners.forEach((listener) => gameObject.off("pointerdown", listener));
        if (commendationType === COMMENDATION.GRAND) {
            fruitData.jackpotMajorWin = false;
            fruitData.jackpotGrandWin = false;
            playEnkC(true)
            setCommendationType(COMMENDATION.NONE);
            tweenFade(backgroundBlur, false, 0.2);
            commendationAmount = 0;
            delayedCall = null;
            delayedCalls = [];

            loopCalls = [];
            loopCall = null
            textObject.visible = false;
            backgroundBlur.interactive = false;

            setTimeout(() => {
                gameObject.visible = false;
                gameObject.interactive = false;
                restartGame();
            }, 1000)
        }

    });
    delayedCalls.push(delayedCall);
};


const stopNumberCounter = (textObject, amt) => {
    fruitData.showWinAmount = false;

    stopDelayedCalls()
    textObject.visible = true
    gsap.killTweensOf(textObject);
    textObject.scale.set(1);
    textObject.text = amt.toFixed(2);
}

const increaseNumCount = (textGameObject, value, duration = 8) => {
    textGameObject.text = 0;
    incrementValue(
        textGameObject,
        value, //winningAmount(),
        duration
    );
};

const stopDelayedCalls = () => {
    delayedCalls.forEach((c) => {
        if (c) c.kill();
    });
    delayedCall = null;
    delayedCalls = [];
}

export const clickToStopCommendation = (
    backgroundBlur,
    gameObject,
    textObject,
    amt,
    index
) => {

    delayedCalls.forEach((c) => {
        if (c) c.kill();
    });
    delayedCall = null;
    delayedCalls = [];

    if (fruitData.showAmount) {

        fruitData.showAmount = false;
        textObject.visible = true
        gsap.killTweensOf(textObject);
        textObject.scale.set(1);
        textObject.text = Number(amt).toFixed(2);

        if (fruitData.jackpotMinorWin || fruitData.jackpotMajorWin || (fruitData.jackpotGrandWin && checkGrandJackpotVisible() === false)) {
            delayedCall = gsap.delayedCall(4, () => {
                callJackpot(gameObject, textObject);
            });
            delayedCalls.push(delayedCall);
        } else {
            delayedCall = gsap.delayedCall(4, () => {
                clearGame(gameObject, textObject, backgroundBlur, index);
            });

            delayedCalls.push(delayedCall);
        }
    } else if (fruitData.jackpotMinorWin || fruitData.jackpotMajorWin || fruitData.jackpotGrandWin) {

        callJackpot(gameObject, textObject);
    } else {

        clearGame(gameObject, textObject, backgroundBlur, index);
    }

};

const callJackpot = (gameObject, textObject) => {
    loopCalls.forEach((c) => {
        if (c) c.kill();
    })
    loopCall = null;
    loopCalls = []

    stopCoinAnimation()
    gameObject.visible = false;
    textObject.visible = false;
    gameObject.interactive = false;
    listeners.forEach((listener) => gameObject.off("pointerdown", listener));
    instances.winScreen.jackpot()
}

const clearGame = (gameObject, textObject, backgroundBlur, index) => {
    stopCoinAnimation()

    setUpAnimation(gameObject, index, false)

    delayedCalls.forEach((c) => {
        if (c) c.kill();
    });
    delayedCall = null;
    delayedCalls = [];

    loopCalls.forEach((c) => {
        if (c) c.kill();
    })
    loopCall = null;
    loopCalls = []

    listeners.forEach((listener) => gameObject.off("pointerdown", listener));

    tweenScaleDisAppear(textObject, false);
    backgroundBlur.interactive = false;

    tweenFade(backgroundBlur, false, 0.2);

    gsap.delayedCall(0.2, () => {
        playMegaAudio(false)
        playMiniAudio(false)
        playUltraAudio(false)
        playEnkC(true)
    });

    setTimeout(() => {
        gameObject.visible = false;
        gameObject.interactive = false;
        restartGame();
    }, 1000)

}
